// Stores
export * from './stores';

// Bridges
export * from './bridges';

// Types
export * from './types';

// Services
export * from './services';
// Utils
export * from './utils';

// Initialize and expose globally
import * as stores from './stores';
import * as bridges from './bridges';
import type * as types from './types';
import * as services from './services';
import * as utils from './utils';

export interface TLShared {
  // Namespaced access (for organization)
  stores: typeof stores;
  bridges: typeof bridges;
  types: typeof types;
  services: typeof services;
  utils: typeof utils;
  // Direct access to commonly used functions (for imports)
  createLogger: typeof bridges.createLogger;
  getLogger: typeof bridges.getLogger;
  getService: typeof bridges.getService;
  broadcast: typeof bridges.broadcast;
  initViewSettingsBridge: typeof bridges.initViewSettingsBridge;
  formatTimestamp: typeof utils.formatTimestamp;
}

// Make available globally for externalized components
// Functions are exposed both namespaced (bridges.createLogger) and flat (createLogger)
const tlShared: TLShared = {
  stores,
  bridges,
  types: {} as typeof types,
  services,
  utils,
  // Flat exports for cleaner imports: import { createLogger } from '@tl-shared'
  createLogger: bridges.createLogger,
  getLogger: bridges.getLogger,
  getService: bridges.getService,
  broadcast: bridges.broadcast,
  initViewSettingsBridge: bridges.initViewSettingsBridge,
  formatTimestamp: utils.formatTimestamp,
};

declare global {
  interface Window {
    TLShared: TLShared;
  }
}

window.TLShared = tlShared;

console.log('[TLShared] Loaded and available at window.TLShared');
